<div class='accordion' #accordion *ngFor="let navigationItem of rootNavigation">
  <section class='accordion-item' *ngIf="moduleAccessService.currentUserHasAccessTo(navigationItem.module)">
    <div class='accordion-title' (click)="accordion.classList.toggle('toggled')"
      [routerLinkActiveOptions]="{ exact: true }">
      <div class='title-with-icon'>
        <mat-icon [inline]='true'>{{navigationItem.icon}}</mat-icon>
        <span class='active' mat-button>{{navigationItem.translateName | translate}}</span>
      </div>
      <mat-icon [ngClass]="{'rotate': expand}">chevron_right</mat-icon>
    </div>
    <div class='accordion-item-content'>
      <nav style="display: grid;">
        <div>
          <ng-container *ngFor="let subNavigationItem  of navigationItem.subNavigationItems; let i = index">
            <ng-container *ngIf="moduleAccessService.currentUserHasAccessTo(subNavigationItem.module)">
              <div *ngIf="subNavigationItem.disabled && subNavigationItem.display !== false">
                <div class='accordion-title disabled'>
                  <div class="pl-48">
                    {{subNavigationItem.translateName | translate}}
                  </div>
                </div>
              </div>
              <a routerLink="{{subNavigationItem.path}}" class="accordion-link" [ngClass]="{'none': subNavigationItem.display === false}"
                routerLinkActive #rlaShipment="routerLinkActive" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
                *ngIf="!subNavigationItem.disabled">
                <div class='accordion-title' [class.active]="rlaShipment.isActive">
                  <div class="pl-48">
                    {{subNavigationItem.translateName | translate}}
                  </div>
                </div>
              </a>
            </ng-container>
          </ng-container>
        </div>
      </nav>
    </div>
  </section>
</div>